<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<ng-container *ngIf='inMenu; then menuTemplate; else buttonTemplate'></ng-container>

<ng-template #menuTemplate>
    <div mat-menu-item (click)='showLogout()'>
        <mat-icon *ngIf='showIcon' svgIcon="logout"></mat-icon>
        <span>Sign out</span>
    </div>
</ng-template>

<ng-template #buttonTemplate>
    <ng-container *ngIf='showIcon; then iconButtonTemplate; else textButtonTemplate'></ng-container>
</ng-template>

<ng-template #iconButtonTemplate>
    <button mat-icon-button
            (click)="showLogout()"
            matTooltip="Sign out">
        <mat-icon svgIcon="logout"></mat-icon>
    </button>
</ng-template>

<ng-template #textButtonTemplate>
    <button mat-button (click)="showLogout()" matTooltip="Sign out">
        Sign Out
    </button>
</ng-template>
